export enum ContractStatusEnum {
    Activated = "ACTIVATED",
    Completed = "COMPLETED", // finished in become not 2-step
    Incomplete = "INCOMPLETE", // unfinished in become
    Confirmed = "CONFIRMED", // confirmed 2-step
    Canceled = "CANCELED", // canceled in order validation
    InValidation = "IN_VALIDATION",
    InDelivery = "IN_DELIVERY",
    Suspended = "SUSPENDED",
    Terminated = "TERMINATED"
}

export enum ContractSubStatusEnum {
    // Incomplete
    Started = "STARTED",
    CompletedPartner = "COMPLETED_PARTNER",
    // Completed
    CompletedCustomer = "CUSTOMER_COMPLETED",
    ConfirmedCustomer = "CUSTOMER_CONFIRMED",
    OrderCompleted = "ORDER_COMPLETED",
    // In Validation,
    BlockedGeneral = "BLOCKED",
    BlockedCredit = "BLOCKED_CREDIT_CHECK",
    BlockedGraydon = "BLOCKED_GRAYDON_DEPOSIT",
    BlockedFraud = "BLOCKED_FRAUD",
    // In Delivery
    OrderValidated = "ORDER_VALIDATED",
    SimSent = "SIM_SENT",
    SimDeliveryFailed = "SIM_DELIVERY_FAILED",
    PortInRequested = "PORT_IN_REQUESTED",
    PortInAccepted = "PORT_IN_ACCEPTED",
    PortInExecuted = "PORT_IN_EXECUTED", // port-in successful
    PortInFailed = "PORT_IN_FAILED",
    ActivationRequested = "ACTIVATION_REQUESTED",
    ActivationExecuted = "ACTIVATION_EXECUTED", // activation successful
    ActivationFailed = "ACTIVATION_FAILED",
}